import { gql } from '@apollo/client';

export const VALIDATE_SHIPPING_ACCOUNT_NO = gql`
  mutation validateShippingAccountNumber($accountNo: String!) {
    validateShippingAccountNumber(accountNo: $accountNo)
  }
`;
